import imageCompression from "browser-image-compression";

const MAX_IMAGE_SIZE_MB = 1;
// api-service uploadService accepts only these extensions and throws "Invalid extension" for anything else
const UPLOADABLE_EXTENSIONS: Record<string, string> = {
	"image/jpeg": "jpg",
	"image/png": "png",
	"image/gif": "gif",
};

export async function blobUrlToCompressedFile(blobUrl: string): Promise<File> {
	const response = await fetch(blobUrl);
	const blob = await response.blob();
	// some sources (camera, clipboard) give a blob without a type — browsers produce png there
	const type = blob.type || "image/png";
	const extension = UPLOADABLE_EXTENSIONS[type];

	if (!extension) {
		// svg, webp etc. — rasterize to png so the backend accepts it
		const png = await imageCompression(new File([blob], "image", { type }), {
			maxSizeMB: MAX_IMAGE_SIZE_MB,
			useWebWorker: false,
			fileType: "image/png",
		});

		return new File([png], "image.png", { type: "image/png" });
	}

	const file = new File([blob], `image.${extension}`, { type });

	if (file.size > MAX_IMAGE_SIZE_MB * 1024 * 1024) {
		return imageCompression(file, {
			maxSizeMB: MAX_IMAGE_SIZE_MB,
			useWebWorker: false,
		});
	}

	return file;
}
